import { Permission } from './permission';
import { getRolePermissions } from './role-permissions';

import { ROLES } from '@data-access';

export function canAccess(
  role: ROLES | undefined,
  permission: Permission,
): boolean {
  if (!role) {
    return false;
  }

  return getRolePermissions(role).has(permission);
}

export type CanAccess = (permission: Permission) => boolean;

export function createCanAccess(role: ROLES | undefined): CanAccess {
  return (permission) => canAccess(role, permission);
}
